// import React from "react";

// function QueueVideo() {
//   return (
//     <div
//       style={{
//         position: "relative",
//         paddingBottom: "60.25%",
//         height: 0,
//       }}
//     >
//       <iframe
//         // src="https://player.vimeo.com/video/1061476820?h=28429ebce7&autoplay=1&loop=1&title=0&byline=0&portrait=0"
//         src="https://www.youtube.com/watch?v=u45HI8yRQcM"
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//         }}
//         frameBorder="0"
//         allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
//       ></iframe>
//     </div>
//   );
// }

// export default QueueVideo;

import React from "react";

function QueueVideo() {
  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "56.25%", // 16:9 aspect ratio
        height: 0,
      }}
    >
      <iframe
        src="https://www.youtube.com/embed/u45HI8yRQcM?autoplay=1&loop=1&playlist=u45HI8yRQcM"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
        allowFullScreen
      />
    </div>
  );
}

export default QueueVideo;
